export default __webpack_public_path__ + "static/1980_1990-8e5669c27cd7a16dd628a20099133dd4.mp4";